export default "__VITE_ASSET__Dfkb9k7z__"